import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Avatar } from 'lmcv/components/Avatar'

import * as S from './styled'

function Header ({ customerName, customerPhoto, projectStatus, projectName }) {
  return (
    <Fragment>
      <S.Photo>
        <Avatar name={customerName} image={customerPhoto} big />
      </S.Photo>

      <Text size="giga">{customerName}</Text>
      <S.ProjectName>{projectName}</S.ProjectName>
      <S.ProjectStatus status={projectStatus.toLowerCase()}>
        {projectStatus}
      </S.ProjectStatus>
    </Fragment>
  )
}

Header.propTypes = {
  customerName: PropTypes.string,
  customerPhoto: PropTypes.string,
  projectName: PropTypes.string.isRequired,
  projectStatus: PropTypes.string.isRequired
}

Header.defaultProps = {
  customerName: 'Nome do usuário'
}

export default Header
